module.exports = __webpack_public_path__ + "img/leak.de66b24.svg";